
export const operationOptions = [
  { value: "IN", text: "Contains" },
  { value: "NOT_IN", text: "Does Not Contains" }
]

export const assetTypesOptions = [
  { value: 'PDF', label: 'PDF', icon: 'pdf' },
  { value: 'VIDEO', label: 'VIDEO', icon: 'video' },
  { value: 'IMAGE', label: 'IMAGE', icon: 'background' },
  { value: 'PPTX', label: 'PPTX', icon: 'pptx' },
  { value: 'PPT', label: 'PPT', icon: 'ppt' },
  { value: 'DOC', label: 'DOC', icon: 'doc' },
  { value: 'DOCX', label: 'DOCX', icon: 'docx' },
  { value: 'YOUTUBE', label: 'YOUTUBE', icon: 'YouTube-2' },
  { value: 'VIMEO', label: 'VIMEO', icon: 'Vimeo' },
  { value: 'WISTIA', label: 'WISTIA', icon: 'video' },
  { value: 'VIDYARD', label: 'VIDYARD', icon: 'video' },
  { value: 'LINK', label: 'LINK', icon: 'link' },
  { value: 'AUDIO', label: 'AUDIO', icon: 'audio' },
  { value: 'SCORM', label: 'SCORM', icon: 'content' },
  { value: 'LANDING_PAGE', label: 'LANDING PAGE', icon: 'landing-page'},
  { value: 'INTERACTIVE_CONTENT', label: 'INTERACTIVE CONTENT', icon: 'Interactive'},
  { value: 'RESOURCE_CENTER', label: 'RESOURCE CENTER', icon: 'resource-center'}
]

export const deviceTypesOptions = [
  { value: 'mobile', label: 'Mobile', icon: 'mobile' },
  { value: 'desktop', label: 'Desktop', icon: 'laptop' },
  { value: 'tablet', label: 'Tablet', icon: 'tablet-ls' },
]

export const continentOptions = [
  { value: 'africa', label: 'Africa' },
  { value: 'antarctica', label: 'Antarctica' },
  { value: 'asia', label: 'Asia' },
  { value: 'europe', label: 'Europe' },
  { value: 'north america', label: 'North America' },
  { value: 'oceania', label: 'Oceania' },
  { value: 'south america', label: 'South America' }
];



export const BrowserTypesOptions = [
  { value: 'chrome', label: 'Chrome' },
  { value: 'edge', label: 'Edge' },
  { value: 'ie', label: 'Internet Explorer' },
  { value: 'safari', label: 'Safari'},
];

export const OSTypeOptions = [
  { value: 'android', label: 'Android' },
  { value: 'ios', label: 'iOS' },
  { value: 'linux', label: 'Linux' },
  { value: 'macos', label: 'macOS' },
  { value: 'windows', label: 'Windows' }
];


export const filterOptions = [{
  value: {
    type: 'ASSET'
  },
  label: 'Asset',
  data_type: 'asset',
  icon: 'doc',
  config: {

  }
}, {
  value: {
    type: 'FILE_TYPE'
  },
  label: 'File Type',
  data_type: 'list',
  icon: 'file-type',
  config: {
    multiple: true,
    options: assetTypesOptions
  }
}, {
  value: {
    type: 'TAGS'
  },
  label: 'Tags',
  data_type: 'tags',
  icon: 'tag',
  config: {
    multiple: true
  }
}]


export const segmentFilterOptions = [
  {
    value: {
      type: 'CONTINENT'
    },
    label: 'Continent',
    data_type: 'list',
    config: {
      multiple: true,
      options: continentOptions
    }
  },
  {
    value: {
      type: 'COUNTRY'
    },
    label: 'Country',
    data_type: 'tags',
    config: {
      multiple: true
    }
  },
  // {
  //   value: {
  //     type: 'STATE'
  //   },
  //   label: 'State',
  //   data_type: 'string',
  //   config: {
  //     multiple: false
  //   }
  // },
  // {
  //   value: {
  //     type: 'CITY'
  //   },
  //   label: 'City',
  //   data_type: 'string',
  //   config: {
  //     multiple: false
  //   }
  // },
  {
    value: {
      type: 'DEVICE_TYPE'
    },
    label: 'Device',
    data_type: 'list',
    config: {
      multiple: true,
      options: deviceTypesOptions
    }
  },
  {
    value: {
      type: 'BROWSER'
    },
    label: 'Browser',
    data_type: 'list',
    config: {
      multiple: true,
      options: BrowserTypesOptions
    }
  },
  {
    value: {
      type: 'OS'
    },
    label: 'Operating System',
    data_type: 'list',
    config: {
      multiple: true,
      options: OSTypeOptions
    },
  },
  {
    value: {
      type: 'UTM_SOURCE'
    },
    label: 'UTM Source',
    data_type: 'string',
    config: {
      multiple: false
    }
  },
  {
    value: {
      type: 'UTM_MEDIUM'
    },
    label: 'UTM Medium',
    data_type: 'string',
    config: {
      multiple: false
    }
  },
  {
    value: {
      type: 'UTM_CAMPAIGN'
    },
    label: 'UTM Campaign',
    data_type: 'string',
    config: {
      multiple: false
    }
  },
  {
    value: {
      type: 'UTM_CONTENT'
    },
    label: 'UTM Content',
    data_type: 'string',
    config: {
      multiple: false
    }
  },
]

export const conditions = [{
  type: 'list',
  options: [{
    value: 'IS',
    label: 'Is'
  }, {
    value: 'IS_NOT',
    label: 'Is Not'
  }, {
    value: 'IS_EMPTY',
    label: 'Is Empty'
  }, {
    value: 'IS_NOT_EMPTY',
    text: 'Is Not Empty'
  }]
}, {
  type: 'asset',
  options: [{
    value: 'IS',
    label: 'Is'
  }, {
    value: 'IS_NOT',
    label: 'Is Not'
  }, {
    value: 'IS_ALL',
    label: 'Is All'
  }]
}, {
  type: 'tags',
  options: [{
    value: 'IS',
    label: 'Is'
  }, {
    value: 'IS_NOT',
    label: 'Is Not'
  }, {
    value: 'IS_EMPTY',
    label: 'Is Empty'
  }, {
    value: 'IS_NOT_EMPTY',
    text: 'Is Not Empty'
  }]
}]



export const segmentConditions = [
  {
  type: 'tags',
  options: [{
    value: 'IS',
    label: 'Is'
  }, {
    value: 'IS_NOT',
    label: 'Is Not'
  }, {
    value: 'CONTAINS',
    label: 'Contains'
  }, {
    value: 'NOT_CONTAINS',
    label: 'Not Contains'
  }, {
    value: 'IS_EMPTY',
    label: 'Is Empty'
  }, {
    value: 'NOT_EMPTY',
    label: 'Is Not Empty'
  }, {
    value: 'STARTS_WITH',
    label: 'Starts With'
  }, {
    value: 'ENDS_WITH',
    label: 'Ends With'
  }]
}]

export const sortOptions = [{
  label: 'Name',
  value: 'name'
}, {
  label: 'Modified Date',
  value: 'modified_date'
}]

export const orderOptions = [{
  label: 'Ascending',
  value: 'ASC'
}, {
  label: 'Descending',
  value: 'DESC'
}]